import { useAtom } from "jotai";
import type { JSX } from "react";

import { CodFluxoEtapaStatus } from "@repo/graphql-types/graphql";

import { ProfessionWithoutCouncilSubStep } from "@/components/flows/steps/council/components/profession-without-council-sub-step";
import {
  ALL_PROFESSIONS,
  PROFESSION_WITHOUT_COUNCIL_DOCUMENTS,
} from "@/components/flows/steps/council/utils/professions";
import { ProgressRoundedLayout } from "@/components/ui/layout/progress-rounded-layout";
import { useSubStepNavigation } from "@/hooks/use-sub-step-navigation";
import { councilStepAtom } from "@/lib/atoms/council-step-atom";
import { useFlowStepContext } from "@/lib/context/flow-step-context";
import { flattenToJsonString } from "@/lib/utils/flatten-to-json-string";

export const TrainingValidationPage = (): JSX.Element => {
  const { step, nextStep, isLoading, progress } = useFlowStepContext();
  const { profession, professionName } = useAtom(councilStepAtom)[0];
  const { goToSubStep } = useSubStepNavigation();

  const acceptedDocuments = profession
    ? PROFESSION_WITHOUT_COUNCIL_DOCUMENTS.get(profession)
    : undefined;

  return (
    <ProgressRoundedLayout
      progress={progress}
      onBack={() => {
        goToSubStep("main");
      }}
    >
      <ProfessionWithoutCouncilSubStep
        acceptedDocuments={acceptedDocuments}
        onSubmit={(trainingFileId) => {
          const resolvedProfessionName =
            professionName ??
            ALL_PROFESSIONS.find((p) => p.value === profession)?.label ??
            null;
          void nextStep({
            ...step,
            resposta: flattenToJsonString({
              profession,
              professionName: resolvedProfessionName,
              trainingFileId,
            }),
            status: CodFluxoEtapaStatus.Concluido,
          });
        }}
        isLoading={isLoading}
      />
    </ProgressRoundedLayout>
  );
};
